import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class CIOD extends Vue {

    @Prop() departmentId!: number;
    @Prop() departmentCode!: string;
    @Prop() departmentName!: string;    
    @Prop() inDateTime!: Date;
    @Prop() outDateTime!: Date;
    @Prop() code!: string;
} 
